import { QUICK_FILTERS, TID } from '@yalidavet/shared';
import { cn } from '@/lib/utils';

interface Props {
  active?: string | null;
  onSelect: (eventTypeId: string | null) => void;
}

/** Pill buttons: Düğün, Nikah, Doğum Günü, Cinsiyet Açıklama, Afterparty, Mezuniyet. */
export default function QuickFilters({ active, onSelect }: Props) {
  return (
    <div
      className="flex flex-wrap items-center gap-2 overflow-x-auto"
      data-testid={TID.quickFilters}
      role="group"
      aria-label="Organizasyon tipi hızlı filtreleri"
    >
      {QUICK_FILTERS.map((f) => {
        const isActive = active === f.id;
        return (
          <button
            key={f.id}
            type="button"
            onClick={() => onSelect(isActive ? null : f.id)}
            aria-pressed={isActive}
            data-testid={TID.quickFilter(f.id)}
            data-active={isActive}
            className={cn('yd-pill', isActive && 'yd-pill-active')}
          >
            {f.label}
          </button>
        );
      })}
    </div>
  );
}
